function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.18 29.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 3.92,
    width: 25.18,
    height: 25.18,
    rx: 1.92,
    ry: 1.92,
    style: {
      fill: "none",
      stroke: "#001dd2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.25,15.45s-.01.11-.02.16c-.08.36-.33.62-.66.76-.22.08-.45.13-.68.13-.41.01-.82-.02-1.22-.16-.1-.04-.16-.11-.16-.22v-.5c0-.11.07-.15.16-.12.27.12.53.19.81.21.22.01.42,0,.63-.07.07-.02.15-.06.19-.12.12-.13.11-.33-.02-.46-.11-.11-.22-.16-.35-.22-.21-.08-.42-.16-.63-.25-.19-.08-.36-.18-.52-.33-.18-.16-.28-.36-.31-.6-.02-.23-.02-.47.07-.69.12-.29.35-.48.63-.6.21-.08.41-.13.63-.13h.27c.29,0,.58.06.86.16.06.02.08.06.08.13v.54c0,.11-.07.15-.18.12-.21-.08-.41-.13-.62-.16-.22-.02-.45-.02-.65.06-.12.05-.21.12-.23.25-.02.12,0,.22.07.33.05.06.12.11.18.14.14.08.31.16.48.22.23.08.47.19.69.34.15.11.27.22.35.36.07.13.12.28.13.45v.02c-.01.07-.01.13,0,.19.01.01.01.02.01.05h.01Z",
    style: {
      fill: "none",
      stroke: "#001dd2",
      strokeWidth: ".4px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.69,14.08c-.06-.42-.23-.8-.52-1.12-.4-.45-.89-.66-1.47-.69h-.28c-.07,0-.14.01-.23.02-.02,0-.05.01-.06.01-.59.12-1.04.41-1.37.92-.31.47-.41,1-.31,1.55.11.63.42,1.14.97,1.47.52.31,1.08.39,1.64.25.05-.01.11-.01.15-.02.56-.16.99-.5,1.26-1.01.23-.46.29-.93.22-1.38h0Z",
    style: {
      fill: "none",
      stroke: "#001dd2",
      strokeWidth: ".4px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.69,15c-.16.33-.4.55-.72.66h-.01c-.07.02-.14.05-.22.06-.01,0-.05.01-.06.01h-.12c-.6,0-1.09-.39-1.22-.97-.11-.46-.02-.87.27-1.22.21-.27.48-.41.82-.45.4-.05.75.07,1.03.36.21.21.33.46.36.75.02.27,0,.54-.13.8h0Z",
    style: {
      fill: "none",
      stroke: "#001dd2",
      strokeWidth: ".4px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.23,16.48h-.58c-.08,0-.12-.02-.13-.11-.31-1.04-.62-2.09-.93-3.12-.07-.25-.15-.52-.23-.76-.02-.11.01-.16.12-.16h.69c.08,0,.12.01.15.11.28.93.56,1.87.83,2.79.01.02.01.06.05.07.05.01.07,0,.08-.06.05-.14.08-.29.13-.46.23-.8.47-1.6.7-2.37.02-.07.06-.11.13-.11h.7c.11,0,.15.06.12.16-.39,1.29-.76,2.59-1.16,3.89-.02.08-.06.11-.14.11-.16.01-.35.01-.54.01h.01Z",
    style: {
      fill: "none",
      stroke: "#001dd2",
      strokeWidth: ".4px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.11,16.52c-.08,0-.13-.05-.13-.13v-.59c0-.11.05-.15.14-.15h3.42c.08,0,.13.05.13.13v.6c0,.08-.05.14-.13.14h-3.43Z",
    style: {
      fill: "none",
      stroke: "#001dd2",
      strokeWidth: ".4px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.81,12.33h1.7c.11,0,.13.05.13.14v.56c0,.08-.05.13-.13.13h-3.43c-.08,0-.13-.05-.13-.13v-.58c0-.08.05-.13.13-.13h1.73Z",
    style: {
      fill: "none",
      stroke: "#001dd2",
      strokeWidth: ".4px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.28,14.84h-1.17c-.08,0-.13-.05-.13-.13v-.59c0-.08.05-.13.13-.13h2.38c.08,0,.13.05.13.13v.6c0,.08-.05.13-.13.13-.41-.01-.81-.01-1.21-.01Z",
    style: {
      fill: "none",
      stroke: "#001dd2",
      strokeWidth: ".4px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.5.5c.47,0,.86.39.86.86v2.56h-1.7V1.36c0-.47.39-.86.86-.86h-.02Z",
    style: {
      fill: "none",
      stroke: "#001dd2"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGid);
export default __webpack_public_path__ + "static/media/GID.d589dac1c465a13269e95d7eb9611f31.svg";
export { ForwardRef as ReactComponent };